import { render, staticRenderFns } from "./PurPayableModal.vue?vue&type=template&id=98c4a594&scoped=true&"
import script from "./PurPayableModal.vue?vue&type=script&lang=js&"
export * from "./PurPayableModal.vue?vue&type=script&lang=js&"
import style0 from "./PurPayableModal.vue?vue&type=style&index=0&id=98c4a594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c4a594",
  null
  
)

export default component.exports